// 表单提示
import React from 'react';
import styles from './TooltipUI.module.less';
import { FormMode } from './types';

enum TOOLTIP_MODES {
  FIELD = 'field',
  ROW = 'row',
  IMG = 'img',
}

const useTooltip = ({
  tooltip,
  tooltipMode,
  mode,
}: {
  tooltip: string;
  tooltipMode: TOOLTIP_MODES;
  mode: FormMode;
}) => {
  const TooltipUI = () => {
    if (tooltipMode === TOOLTIP_MODES.ROW) {
      return (
        <div
          className={styles['tooltip-ui']}
          dangerouslySetInnerHTML={{ __html: tooltip }}
        ></div>
      );
    }

    if (tooltipMode === TOOLTIP_MODES.IMG) {
      return (
        <div className={styles['tooltip-ui']}>
          <div>示例：</div>
          <img src={tooltip} />
        </div>
      );
    }

    return null;
  };

  const toolTipUIShow = mode === FormMode.Edit;

  const formItemPropsTooltip = [TOOLTIP_MODES.FIELD, undefined].includes(
    tooltipMode,
  )
    ? tooltip
    : '';
  return {
    TooltipUI,
    toolTipUIShow,
    formItemPropsTooltip,
  };
};

export default useTooltip;
